import { css } from 'styled-components'

export const Connectivity = css``
